const validateEmpty = (value, validation) => { 
    if (validation.required) {
        switch (validation.type) {
            case "String":
            case "Number":
            case "Decimal":
                return !!value && value !== "";
            case "Boolean":
                return typeof value === "boolean" || (!!value && value !== "");
            case "Measurement":
                return !!value.uom && value.uom !== "" && !!value.value && value.value !== "";
            case "Picklist":
                const simplePicklist = !!value && value.hasOwnProperty("value") && value.value !== "";
                const multiPicklist = !!value && value.length > 0;

                return simplePicklist || multiPicklist;
            case "StringList":
            case "LinkList":
            case "NumberList":
            case "MeasurementList":
                return !!Array.isArray(value) && !!value.length;
            default:
                return !!value;
        }
    }

    return true;
};

const validatePattern = (value, validation) => {
    if (!value || !validation.regEx) {
        return true;
    }

    const re = new RegExp(validation.regEx);
    const isMatch = value.match(re);

    return !!isMatch;
};

const validateMinLength = (value, validation) => {
    const valueLength = value ? value.length : 0;

    return !(validation.min && validation.min > valueLength);
};

const validateMaxLength = (value, validation) => {
    const valueLength = value ? value.length : 0;

    return !(validation.max && validation.max < valueLength);
};

const AddToMinAndMaxCharValidations = (valueToAdd, validation) => {
    validation.min = validation.min + valueToAdd;
    validation.max = validation.max + valueToAdd;
};

const validateDecimalInput = (value, validation) => {
    const response = {
        isValid: true,
        errorMsg: [],
    };
    var shouldCheckMaxChars = true;
    var shouldCheckMinChars = true;
    var decimalRegExString = /^\d*(\.\d+)?$/;

    if (value && !decimalRegExString.test(value)) {
        response.isValid = false;
        response.errorMsg.push("Number is not valid.");
    }

    const isDecimalNumber = value % 1 !== 0;

    if (!validation.min || validation.min === 0) shouldCheckMinChars = false;

    if (!validation.max || validation.max === 0) shouldCheckMaxChars = false;

    if (isDecimalNumber) {
        AddToMinAndMaxCharValidations(1, validation);
    }

    if (shouldCheckMinChars && !validateMinLength(value, validation)) {
        response.isValid = false;
        response.errorMsg.push(`Minimum character length (${isDecimalNumber ? validation.min - 1 : validation.min}) not met.`);
    }

    if (shouldCheckMaxChars && !validateMaxLength(value, validation)) {
        response.isValid = false;
        response.errorMsg.push(`Maximum character length (${isDecimalNumber ? validation.max - 1 : validation.max}) exceeded.`);
    }

    if (isDecimalNumber) {
        AddToMinAndMaxCharValidations(-1, validation);
    }

    return response;
};

const validateStringListMaxLength = (value = "", validation) => {
    if (value.length > 0) {
        value = value.join("");
    }

    const valueLength = value ? value.length : 0;

    return !(validation.max && validation.max < valueLength);
};

export const validateInput = (value, validation) => {
    const response = {
        isValid: true,
        errorMsg: [],
    };

    if (!validation) {
        return response;
    }

    if (!validateEmpty(value, validation)) {
        response.isValid = false;
        response.errorMsg.push(`Required field`);
    }

    if (!validatePattern(value, validation)) {
        response.isValid = false;
        response.errorMsg.push(validation.regExFailureMessage);
    }

    switch (validation.type) {
        case "Decimal":
            var validationResult = validateDecimalInput(value, validation);

            if (!validationResult.isValid) {
                response.isValid = false;
                response.errorMsg = validationResult.errorMsg;
            }

            break;
        case "StringList":
            if (!validateStringListMaxLength(value, validation)) {
                response.isValid = false;
                response.errorMsg.push(`Maximum character length (${validation.max}) exceeded.`);
            }

            break;
        default:
            if (!validateMinLength(value, validation)) {
                response.isValid = false;
                response.errorMsg.push(`Minimum character length (${validation.min}) not met.`);
            }

            if (!validateMaxLength(value, validation)) {
                response.isValid = false;
                response.errorMsg.push(`Maximum character length (${validation.max}) exceeded.`);
            }

            break;
    }

    return response;
};
